import { Container, Row, Col } from 'react-bootstrap';

const Footer = () => {
    return (
        <footer className='bg-body-tertiary'>
            <Container style={{position:'absolute', bottom:'0', backgroundColor:'white', margin:'0'}}>
                        <p style={{fontFamily : 'monospace', 
                        color : 'grey', 
                        fontWeight: 'bold', 
                        marginLeft : '0.5%',
                        padding:'1%',
                        fontSize : '10px'}}>© 2024 AlgoBrawl</p>
            </Container>
        </footer>
    );
}

export default Footer;